// 格式化视频播放时间
export const formatTime = time => {
  time = parseInt(time)

  // let iHour = Math.floor(time / 3600) + ''
  let iMin = Math.floor((time % 3600) / 60) + ''
  let iSec = Math.floor(time % 60) + ''

  const toDouble = str => {
    return ('00' + str).substr(str.length)
  }
  return `${toDouble(iMin)}:${toDouble(iSec)}`
}

// 格式化时间
export const formatPassTime = nowTime => {
  let currentTime = Date.now()
  let time = currentTime - Date.parse(nowTime)
  let day = parseInt(time / (1000 * 60 * 60 * 24), 10)
  let hours = parseInt(time / (1000 * 60 * 60), 10)
  let min = parseInt(time / (1000 * 60), 10)
  let month = parseInt(day / 30, 10)
  let year = parseInt(month / 12, 10)

  if (year) return year + '年前'
  if (month) return month + '月前'
  if (day) return day + '天前'
  if (hours) return hours + '小时前'
  if (min) return min + '分钟前'
  else return '刚刚'
}

// 格式化预览数量
export const formatDigt = val => {
  if (val >= 10000) {
    return Number(val / 10000).toFixed(1) + 'w'
  }
  return val
}
